import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { guaranteeItems } from '../data/content';
import { CtaButton } from './CtaButton';
export function Guarantee() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-206" data-mp="223y639n82bl6">
      <div className="mx-auto max-w-4xl px-4" data-id="element-207" data-mp="222n156i1ixsh">
        <div className="grid items-start gap-8 md:grid-cols-[auto_1fr] md:gap-12" data-id="element-208" data-mp="1x3tothehpctw">
          <div className="mx-auto grid h-36 w-36 place-items-center rounded-full border-4 border-gold bg-sand text-center md:mx-0 sm:h-44 sm:w-44" data-id="element-209" data-mp="19eqyll5sibns">
            <div data-id="element-210" data-mp="14gz7uugvsvl6">
              <ShieldCheckIcon className="mx-auto h-10 w-10 text-navy" aria-hidden="true" data-id="element-211" data-mp="14hh6tyuxhnws" />
              <p className="mt-1 font-display text-4xl font-bold leading-none text-navy" data-id="element-212" data-mp="1j5v9o9schcdc">7</p>
              <p className="text-xs font-extrabold uppercase tracking-wider text-navy" data-id="element-213" data-mp="1ec9a9jb6z4zh">Day Guarantee</p>
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-214" data-mp="lp6aknus4o7n">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-accent sm:text-sm" data-id="element-215" data-mp="lon546mbfsai">Your 7-Day Guarantee</p>
            <h2 className="mt-3 text-balance font-display text-[30px] font-bold leading-[1.12] text-ink sm:text-4xl" data-id="element-216" data-mp="oxfaqaxb4rt3">
              Explore Third Molar Assessment Blueprint™ Before Deciding Whether It’s Right for You
            </h2>
            <div className="mt-4 space-y-3 text-[17px] leading-relaxed text-ink/85" data-id="element-217" data-mp="12qoffyab8p5a">
              <p data-id="element-218" data-mp="60njnfbix8eh">
                I want you to have the opportunity to review the material and decide whether it fits your educational and professional
                needs.
              </p>
              <p data-id="element-219" data-mp="b1l8gar1h0oy">That’s why your purchase comes with a 7-day guarantee, subject to the published refund terms.</p>
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-3xl bg-sand p-6 sm:p-8" data-id="element-220" data-mp="k185kkcqjkc7">
          <p className="font-bold text-ink" data-id="element-221" data-mp="1qh0m75ttkfua">During that period, you can:</p>
          <ul className="mt-4 grid gap-2.5 sm:grid-cols-2 sm:gap-x-8" data-id="element-222" data-mp="1vflln318yvho">
            {guaranteeItems.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-relaxed text-ink" data-id="element-223" data-mp="3ri75nvwc25rx">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-224" data-mp="3nhobhv6ywnmk" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-8 max-w-2xl space-y-3 text-center text-[17px] leading-relaxed text-ink/85" data-id="element-225" data-mp="cfhh224937r">
          <p data-id="element-226" data-mp="38rz4vkg3vrew">
            If the product doesn’t meet your expectations, follow the refund instructions provided with your purchase within the guarantee
            period.
          </p>
          <p className="font-semibold text-ink" data-id="element-227" data-mp="3ii1z1nyyrbet">My goal is to make your decision straightforward and transparent.</p>
        </div>

        <div className="mt-10" data-id="element-228" data-mp="3dr1z09ujsd83">
          <CtaButton label="Get Third Molar Assessment Blueprint™ — 7-Day Guarantee" data-id="element-229" data-mp="3dq0pi9t6jysh" />
        </div>
      </div>
    </section>;
}